import { render, staticRenderFns } from "./loadingModal.vue?vue&type=template&id=28b28782&scoped=true&"
import script from "./loadingModal.vue?vue&type=script&lang=js&"
export * from "./loadingModal.vue?vue&type=script&lang=js&"
import style0 from "./loadingModal.vue?vue&type=style&index=0&id=28b28782&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b28782",
  null
  
)

export default component.exports